import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext'; // NEW
import MobileShell from './MobileShell';

import { UpcomingAssignments, UpcomingEvents, YourEndeavors } from '../components';
import MobileMyDocumentsCard from './components/MobileMyDocumentsCard';
import MobileCourseDetailsPage from './pages/MobileCourseDetailsPage';
import MobileAssignmentDetailsPage from './pages/MobileAssignmentDetailsPage';
import MobileEventDetailsPage from './pages/MobileEventDetailsPage';
import MobileCourseEventsPage from './pages/MobileCourseEventsPage';
import MobileCourseAssignmentsPage from './pages/MobileCourseAssignmentsPage';
import MobileChatPage from './pages/MobileChatPage';
import MobileCourseDocumentsPage from './pages/MobileCourseDocumentsPage';
import MobileEventAssignmentsPage from './pages/MobileEventAssignmentsPage';
import MobileDocumentViewPage from './pages/MobileDocumentViewPage';
import MobileDocumentEditPage from './pages/MobileDocumentEditPage';
import MobileAssignmentEditPage from './pages/MobileAssignmentEditPage';
import MobileCourseEditPage from './pages/MobileCourseEditPage';
import MobileEventEditPage from './pages/MobileEventEditPage';
// Purpose-built mobile landing page
import MobileLandingPage from './pages/mobile_landing/MobileLandingPage';
import MobileAboutPage from './pages/MobileAboutPage';
import MobileContactPage from './pages/MobileContactPage';
import MobileLoginPage from './pages/MobileLoginPage';
import MobileRegisterPage from './pages/MobileRegisterPage';
import MobileBlogPage from './pages/mobile_public/MobileBlogPage';
import MobileBlogArticlePage from './pages/mobile_public/MobileBlogArticlePage';
import MobileTermsPage from './pages/MobileTermsPage';
import MobilePrivacyPage from './pages/MobilePrivacyPage';
import MobileForgotPasswordPage from './pages/MobileForgotPasswordPage';
import MobileResetPasswordPage from './pages/MobileResetPasswordPage';
import MobileComingSoonPage from './pages/MobileComingSoonPage';
import ResetPasswordPage from '../pages/signin/ResetPasswordPage';
import EmailVerificationPage from '../pages/signin/EmailVerificationPage';
// (Removed duplicated import block)
import ProtectedRoute from '../components/ProtectedRoute';
import CreateEventPage from '../pages/CreateEventPage';
import CreateCourseWizard from '../pages/createEndeavors/CreateCourseWizard';
import CreateAssignmentPage from '../pages/CreateAssignmentPage';
// Removed unused: CourseEdit, AssignmentEdit, EventEdit

// Light mobile wrappers (adjust as needed)
const MobileAssignmentsScreen = () => (
  <div className="m-screen single-card-screen">
    <UpcomingAssignments defaultStatus="incomplete" />
  </div>
);
const MobileEventsScreen = () => (
  <div className="m-screen single-card-screen">
    <UpcomingEvents />
  </div>
);
const MobileCoursesScreen = () => (
  <div className="m-screen single-card-screen">
    <YourEndeavors />
  </div>
);
const MobileDocumentsScreen = () => (
  <div className="m-screen">
    <MobileMyDocumentsCard selectionMode={false} />
  </div>
);

export default function MobileRoutes(){
  const { accessToken, user } = useAuth();              // NEW
  const isAuthenticated = !!accessToken || !!user;      // NEW

  return (
    <Routes>
      {/* Public auth-related routes accessible directly (no /m prefix) */}
      <Route path="/forgot-password" element={<MobileForgotPasswordPage />} />
      {/* Reset password uses query param ?token=... for consistency with desktop */}
    <Route path="/reset-password" element={<ResetPasswordPage />} />
    <Route path="/verify-email" element={<EmailVerificationPage />} />
      <Route path="/m" element={<MobileShell />}>
    <Route index element={<MobileLandingPage />} />
        <Route path="courses" element={<MobileCoursesScreen />} />
        <Route path="events" element={<MobileEventsScreen />} />
        <Route path="assignments" element={<MobileAssignmentsScreen />} />
        <Route path="documents" element={<MobileDocumentsScreen />} />
        {/* Public mobile pages */}
        <Route path="about" element={<MobileAboutPage />} />
        <Route path="contact" element={<MobileContactPage />} />
        <Route path="coming-soon" element={<MobileComingSoonPage />} />
        <Route path="login" element={<MobileLoginPage />} />
        <Route path="register" element={<MobileRegisterPage />} />
    <Route path="blog" element={<MobileBlogPage />} />
    <Route path="blog/:id" element={<MobileBlogArticlePage />} />
    <Route path="terms" element={<MobileTermsPage />} />
    <Route path="privacy" element={<MobilePrivacyPage />} />
    <Route path="forgot-password" element={<MobileForgotPasswordPage />} />
    {/* Deprecated in-mobile reset-password path using path param retained for backward compatibility */}
    <Route path="reset-password/:token" element={<MobileResetPasswordPage />} />
        {/* Mobile create routes - map to web create pages or modal wrappers */}
        <Route path="create-event" element={
          <ProtectedRoute>
            <CreateEventPage />
          </ProtectedRoute>
        } />
        <Route path="create-course-wizard" element={
          <ProtectedRoute>
            <CreateCourseWizard />
          </ProtectedRoute>
        } />
        <Route path="create-assignment" element={
          <ProtectedRoute>
            <CreateAssignmentPage />
          </ProtectedRoute>
        } />
        <Route path="course/:courseId" element={<MobileCourseDetailsPage />} />
        <Route path="course/:courseId/edit" element={
          <ProtectedRoute>
            <MobileCourseEditPage />
          </ProtectedRoute>
        } />
        <Route path="course/:courseId/events" element={<MobileCourseEventsPage />} />
        <Route path="course/:courseId/assignments" element={<MobileCourseAssignmentsPage />} />
        <Route path="course/:courseId/chat" element={<MobileChatPage />} />
        <Route path="course/:courseId/documents" element={<MobileCourseDocumentsPage />} />
        {/* NEW: top-level AI Chat route */}
        <Route
          path="chat"
          element={
            <ProtectedRoute>
              <MobileChatPage />
            </ProtectedRoute>
          }
        />
        <Route path="assignment/:assignmentId" element={<MobileAssignmentDetailsPage />} />
        <Route path="assignment/:assignmentId/edit" element={
          <ProtectedRoute>
            <MobileAssignmentEditPage />
          </ProtectedRoute>
        } />
        <Route path="event/:eventId" element={<MobileEventDetailsPage />} />
        <Route path="event/:eventId/edit" element={
          <ProtectedRoute>
            <MobileEventEditPage />
          </ProtectedRoute>
        } />
        <Route path="event/:eventId/assignments" element={<MobileEventAssignmentsPage />} />
        <Route path="document/:id" element={
          <ProtectedRoute>
            <MobileDocumentViewPage />
          </ProtectedRoute>
        } />
        <Route path="document/:id/edit" element={
          <ProtectedRoute>
            <MobileDocumentEditPage />
          </ProtectedRoute>
        } />
        {/* Backwards compatibility redirects */}
        <Route path="tasks" element={<Navigate to="/m/assignments" replace />} />
        <Route path="home" element={<Navigate to="/m/courses" replace />} />
        <Route path="*" element={
          <Navigate to={isAuthenticated ? "/m/courses" : "/m"} replace />   // CHANGED
        } />
      </Route>
      {/* Catch-all inside /m: preserve direct auth routes by not intercepting them */}
      <Route path="*" element={<Navigate to={isAuthenticated ? "/m/courses" : "/m"} replace />} />
    </Routes>
  );
}